import * as React from "react";
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { fetchOrden } from '../../actions/ordenesActions';
import { fetchMotivosRevision } from "../../actions/publicacionesActions";
import { getLogoPlataformaById } from "../../helper/ordenHelper";
import { limpiarFiltros } from '../../actions/generalActios';
import DatosComprador from "./DatosComprador";
import BigSpinner from "../General/BigSpinner";
import Estados from "./Estados/EstadosOrden";
import MedioDePago from "./MedioDePago";
import Productos from "./Productos";
import Entrega from "./Entrega";
import Comprobantes from "./Comprobantes";
import PubSectionNav from "../Publicaciones/Components/ABM/PubSectionNav";
import '../Publicaciones/Components/PublicacionStyles.css';
import './OrdenesStyles.css';
import GoBackArrow from "../General/GoBackArrow";
import PropTypes from 'prop-types';

const SECTION_GROUPS = [
    { label: "Venta", match: /comprador|producto/i },
    { label: "Logística y pago", match: /entrega|medio/i },
    { label: "Seguimiento", match: /estado|comprobante/i },
];

// Wrapper para usar hooks en class component
function OrdenEditWrapper(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    return <OrdenEdit {...props} navigate={navigate} id={id} location={location} />;
}



class OrdenEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            tabs: [
                { name: "Datos comprador", icon: "ti-user", content: <DatosComprador idOrden={this.props.id} newOrden={false} /> },
                { name: "Productos", icon: "ti-package", content: <Productos newOrden={false} /> },
                { name: "Entrega", icon: "sl-icon-globe", content: <Entrega /> },
                { name: "Medio de pago", icon: "sl-icon-wallet", content: <MedioDePago newOrden={false} /> },
                { name: "Estados", icon: "sl-icon-layers", content: <Estados history={this.props.history} /> },
                { name: "Comprobantes", icon: "sl-icon-docs", content: <Comprobantes /> }
            ]
        }
    }

    componentDidMount() {
        this.props.fetchOrden(this.props.id, this.props.userId);
        this.props.fetchMotivosRevision();
    }

    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }


    return = () => {
        if (this.props.emptyFiltro.ordenes === false) {
            this.props.limpiarFiltros({
                publicaciones: true,
                ordenes: false,
                sellers: true,
                showFiltro: false,
                showFiltroOrdenes: true
            })
        }

        const pathReturn = this.props.location.state || "/Ordenes";
        this.props.navigate(`${pathReturn}`);
    }


    render() {
        const { orden, userType, loadingOrdenes } = this.props;
        const { tabs, activeTab } = this.state;
        const numeroOrden = this.props.id;
        const hasOrden = orden != undefined && JSON.stringify(orden) != "{}";
        const idVendedorBoca = hasOrden ? orden.idVendedorBoca : null;
        const imgLogo = hasOrden
            ? (orden?.seller?.urlLogo != ""
                ? orden.seller.urlLogo
                : getLogoPlataformaById(orden.plataforma.codigo))
            : null;

        return (
            <div className="container py-2">
                {loadingOrdenes ? (
                    <div className="card pub-editor border-0 admin-form-loading d-flex align-items-center justify-content-center py-5">
                        <BigSpinner message="Cargando detalle de la orden..." />
                    </div>
                ) : (
                    <div className="card pub-editor ord-editor border-0">
                        <header className="pub-editor__header">
                            <GoBackArrow />
                            <div className="min-w-0">
                                <p className="pub-editor__kicker">Detalle de orden</p>
                                <h4 className="pub-editor__title text-truncate">Orden {numeroOrden}</h4>
                                <div className="pub-editor__meta">
                                    <span className="pub-editor__id">#{numeroOrden}</span>
                                    {hasOrden && orden?.seller?.descripcion &&
                                        <span className="ord-editor__seller">{orden.seller.descripcion}</span>
                                    }
                                </div>
                            </div>
                            {userType.isAdminMod && hasOrden &&
                                <div className="ord-editor__brand">
                                    {imgLogo && <img className="orden-detail-logo" alt="icon_mega" src={imgLogo} />}
                                    {idVendedorBoca != 0 && idVendedorBoca &&
                                        <span className="orden-detail-seller-id">{idVendedorBoca}</span>
                                    }
                                </div>
                            }
                        </header>

                        <div className="pub-editor__body">
                            <div className="pub-editor__workspace">
                                <PubSectionNav
                                    tabs={tabs}
                                    activeTab={activeTab}
                                    onChange={this.onChangeActiveTab}
                                    groups={SECTION_GROUPS}
                                    ariaLabel="Secciones de la orden"
                                />
                                <form className="pub-editor__form" onSubmit={this.onSubmit}>
                                    <div className="tab-content">
                                        {tabs[activeTab].content}

                                        <div className="pub-editor__actions">
                                            <button
                                                type="button"
                                                onClick={this.return}
                                                className="btn btn-sm btn-light"
                                            >
                                                Volver
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}OrdenEdit.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        state: PropTypes.object
    }),
    navigate: PropTypes.func,
    // Redux props
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    history: PropTypes.string,
    emptyFiltro: PropTypes.shape({
        ordenes: PropTypes.bool,
    }),
    orden: PropTypes.shape({
        idVendedorBoca: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        seller: PropTypes.shape({
            urlLogo: PropTypes.string,
        }),
        plataforma: PropTypes.shape({
            codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
    loadingOrdenes: PropTypes.bool,
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
    }),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // Actions props
    fetchOrden: PropTypes.func,
    fetchMotivosRevision: PropTypes.func,
    limpiarFiltros: PropTypes.func,
}

const mapStateToProps = state => ({
    orden: state.ordenes.orden,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    emptyFiltro: state.general.limpiar,
    userType: state.general.userType,
    userId: state.general.userId
});

export default connect(mapStateToProps, {
    fetchOrden,
    fetchMotivosRevision,
    limpiarFiltros
})(OrdenEditWrapper);